<template>
  <path
    d="M19 3.00024H5C3.9 3.00024 3 3.90024 3 5.00024V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00024C21 3.90024 20.1 3.00024 19 3.00024ZM17 9.00024H15.3L10.59 17.4902C10.41 17.8002 10.07 18.0002 9.71 18.0002H7C6.17 18.0002 5.5 17.3302 5.5 16.5002C5.5 15.6702 6.17 15.0002 7 15.0002H8.7L13.41 6.51024C13.59 6.20024 13.93 6.00024 14.29 6.00024H17C17.83 6.00024 18.5 6.67024 18.5 7.50024C18.5 8.33024 17.83 9.00024 17 9.00024Z"
  />
</template>
